import { Mapper } from 'module/Common';
import { MzImageResolutionName } from './MzImageResolutionName';
import { MzImageResolution } from './MzImageResolution';

export type MzImageResolutionMap = { [K in MzImageResolutionName]: MzImageResolution };

export namespace MzImageResolutionMap {
  export const mapper = Mapper.schema({
    xxl: MzImageResolution.mapper,
    xl: MzImageResolution.mapper,
    l: MzImageResolution.mapper,
    m: MzImageResolution.mapper,
    s: MzImageResolution.mapper,
    xs: MzImageResolution.mapper,
    xxs: MzImageResolution.mapper,
  });
}



// WEBPACK FOOTER //
// ./src/module/Model/MzImage/MzImageResolutionMap.ts